import { FC, ReactNode } from 'react';
import { NudosButton, NudosGenericModal } from '../../../../../../../../../components/NudosComponents';
import { IconWarning } from '../../../../../../../../../assets/DesignSystem/SVGComponents';

import './DeleteModalTag.scss';

interface IAlertInfo {
  infoDetails: ReactNode;
  textFirstButton: string;
  textSecondButton: string;
  closeModal: () => void;
  secondButtonAction: () => void;
}

export interface IDeleteModalTag {
  alertInfo: IAlertInfo;
  loader?: boolean;
}

const DeleteModalTag: FC<IDeleteModalTag> = ({ alertInfo, loader }: IDeleteModalTag) => {
  return (
    <NudosGenericModal
      modalContent={
        <div id="DeleteModalTag">
          <div className="alertIconContainer">
            <div className="containerYellowIconWarning">
              <IconWarning className="iconScale" />
            </div>
          </div>
          {alertInfo?.infoDetails}
          <div className="buttonsDeleteTagsContainer">
            <NudosButton
              buttonText={alertInfo.textFirstButton}
              customWidth="180px"
              customHeight="38px"
              colorPalette="secondary"
              handleClick={alertInfo.closeModal}
            />
            <NudosButton
              buttonText={alertInfo.textSecondButton}
              customWidth="180px"
              customHeight="38px"
              handleClick={alertInfo.secondButtonAction}
              isButtonDisabled={loader}
              isButtonLoading={loader}
            />
          </div>
        </div>
      }
    />
  );
};

export default DeleteModalTag;
